import { theme } from '@/modules/common/theme';
import {
  isManualArea,
  isRackingArea,
  isSingularStationArea,
  isStationaryArea,
} from '@/modules/floorplanDesign/helpers/typeguards';
import { Area } from '@/modules/floorplanDesign/types';

export const STROKE_COLOR = '#222';

export const AREAS_COLORS_MAP = {
  HIGHWAY: theme.palette.areas.highway,
  INTAKE: theme.palette.areas.intake,
  DELIVERY: theme.palette.areas.delivery,
  STORAGE: theme.palette.areas.storage,
  INTAKE_AND_DELIVERY: theme.palette.areas.storage,
  OFF_VEHICLE_PROCESSING: theme.palette.areas.offVehicleProcess,
  ON_VEHICLE_PROCESSING: theme.palette.areas.onVehicleProcess,
  PARKING: theme.palette.areas.parking,
  CHARGING: theme.palette.areas.charging,
  INSERTION: theme.palette.areas.insertion,
  EXTRACTION: theme.palette.areas.extraction,
  OBSTACLE: theme.palette.areas.obstacle,
  LOGICAL_SPACE: theme.palette.areas.logicalSpace,
  JIT_POINT: theme.palette.areas.jitPoint,
  MANUAL: theme.palette.areas.manual,
  LANE: theme.palette.areas.laneColor,
};

export const getAreaColorByArea = (area: Area, fallback = theme.palette.neutral.grey): string => {
  if (isManualArea(area)) return AREAS_COLORS_MAP.MANUAL;
  if (isRackingArea(area)) return AREAS_COLORS_MAP[area.rackingLoadHandlingType];
  if (isSingularStationArea(area)) return AREAS_COLORS_MAP[area.loadHandlingType];
  if (isStationaryArea(area)) return AREAS_COLORS_MAP[area.stationaryType];

  return fallback;
};

export const modifyColor = (
  color: string,
  transparentFill?: boolean,
  transparency?: string,
): string => {
  if (transparency) {
    return color + transparency;
  }

  if (transparentFill) {
    return `${color}44`;
  }

  return `${color}FF`;
};
